import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectHelperService {

  redirectToGroupUnderwriting(authCode: string): void {
    const params = this.buildAuthCodeParams(authCode);
    const targetUrl = `${environment.SALESFORCE_AUTH.underwritingRedirectUrl}?${params.toString()}`;
    window.location.href = targetUrl;
  }

  redirectToGroupSales(authCode: string): void {
    const params = this.buildAuthCodeParams(authCode);
    const targetUrl = `${environment.SALESFORCE_AUTH.salesforceRedirectUrl}?${params.toString()}`;
    window.location.href = targetUrl;
  }

  redirectToAdminPortal(authCode: string): void {
    const params = this.buildAuthCodeParams(authCode);
    const targetUrl = `${environment.SALESFORCE_AUTH.adminPortalRedirectUrl}?${params.toString()}`;
    window.location.href = targetUrl;
  }

  redirectToEmployerPortal(authCode: string): void {
    const params = this.buildAuthCodeParams(authCode);
    const targetUrl = `${environment.ON_CUSTOMIDP_Auth.employerPortal}?${params.toString()}`;
    window.location.href = targetUrl;
  }

  redirectToSalesForce(authCode: string): void {
    const params = this.buildAuthCodeParams(authCode);
    const targetUrl = `${environment.SALESFORCE_AUTH.salesforceRedirectUrl}?${params.toString()}`;
    window.location.href = targetUrl;
  }

  redirectByRole(authCode: string, selectedRole: string): void {
    switch (selectedRole) {
      case 'N_GS':
        this.redirectToGroupSales(authCode);
        break;
      case 'N_GU':
        this.redirectToGroupUnderwriting(authCode);
        break;
      case 'N_GA':
        this.redirectToAdminPortal(authCode);
        break;
      case 'N_HR':
        this.redirectToEmployerPortal(authCode);
        break;
      case 'N_ME':
        this.redirectToEmployerPortal(authCode);
        break;
      case 'SALESFORCE':
        this.redirectToSalesForce(authCode);
        break;
      default:
        console.error('Unknown role:', selectedRole);
        this.redirectToGroupSales(authCode);
    }
  }

  private buildAuthCodeParams(authCode: string): URLSearchParams {
    const params = new URLSearchParams();
    params.set('authCode', authCode);
    return params;
  }
}